var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCornerResizeHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "se corner handle",
  viewBox: "0 0 25 25"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 25H0L25 0v19a6 6 0 0 1-6 6Z",
  style: {
    fill: "#177991"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.48 22.35-1.7-1.7 5.86-5.86 1.7 1.7Zm5.87-11.85-1.7-1.7L8.83 20.62l1.7 1.7Z",
  "data-name": "grabber lines"
})));
export default SvgIconCornerResizeHandle;